<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <v-card>
      <v-card-title class="headline text-xs-center">{{ messages.title }}</v-card-title>
      <v-card-text class="text-xs-center dialog-text" v-html="messages.text"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="yellow darken-2" flat @click="close(false)">{{ messages.cancel }}</v-btn>
        <v-btn color="green darken-1" flat @click="close(true)">{{ messages.confirm }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
  export default {
    name: "ConfirmDialog",
    props: {
      messages: {
        type: Object
      }
    },
    data () {
      return {
        dialog: true
      };
    },
    methods: {
      close(value) {
        this.$emit('close', value)
      }
    }
  }
</script>

<style>
  .dialog-text a {
    color: deepskyblue;
  }
</style>